import { gql } from "@apollo/client";

export const CREATE_EQUIPMENT = gql`
    mutation createEquipment($sku: String!, $category: ID!, $quantity: Int!, $name: String!, $description: String, $itemWeightInLbs: Decimal!) {
        createEquipment(sku: $sku, category: $category, quantity: $quantity, name: $name, description: $description, itemWeightInLbs: $itemWeightInLbs) {
            equipment {
                id
            }
        }
    }
`

export const EDIT_EQUIPMENT = gql`
    mutation editEquipment($id: Int!, $sku: String!, $category: ID!, $name: String!, $description: String, $itemWeightInLbs: Decimal!) {
        editEquipment(id: $id, sku: $sku, category: $category, name: $name, description: $description, itemWeightInLbs: $itemWeightInLbs) {
            equipment {
                id
            }
        }
    }
`

export const DELETE_EQUIPMENT = gql`
    mutation deleteEquipment($id: Int!) {
        deleteEquipment(id: $id) {
            didDelete
        }
    }
`

export const REFRESH_EQUIPMENT_QUANTITY = gql`
    mutation refreshEquipmentQuantity($id: ID!) {
        refreshEquipmentQuantity(id: $id) {
            quantity
        }
    }
`